// extracted by mini-css-extract-plugin
module.exports = {"splitBackground":"style-module--split-background--KskvC","left":"style-module--left--1nK6u","right":"style-module--right--19FxN","center":"style-module--center--2srtp"};